import { createReducer, on } from '@ngrx/store';
import {
  DirectoryTemplateActions,
  DirectoryAPIActions,
} from './directory.actions';
import { Section } from './model/directory.model';

export interface DirectoryState {
  loading: boolean;
  error: string;
  sections: Section[];
}

export const initialState: DirectoryState = {
  loading: true,
  error: '',
  sections: [],
};

export const directoryReducer = createReducer(
  initialState,
  on(DirectoryTemplateActions.setSections, (state, { sections }) => ({
    ...state,
    loading: false,
    sections: sections,
    error: '',
  })),
  on(DirectoryAPIActions.loadSections, state => ({
    ...state,
    loading: true,
    sections: [],
    error: '',
  })),
  on(DirectoryAPIActions.sectionsLoadedSuccess, (state, { sections }) => ({
    ...state,
    loading: false,
    sections,
  })),
  on(DirectoryAPIActions.sectionsLoadedFail, (state, { message }) => ({
    ...state,
    sections: [],
    loading: false,
    error: message,
  }))
);
